// src/rtkQuery/config/products.config.ts
export const PRODUCT_ENDPOINTS = {
    GET_PRODUCT_LIST: '/products/list',
    GET_PRODUCT_DETAILS: '/products/details',
    GET_PRODUCTS_BY_CATEGORY: '/products/category',
    GET_PRODUCTS_YOUR_OPTIONS: '/products/yourOptions',
    POST_PRODUCTS_SHIPPING_POLICY: '/products/shipping',
} as const;